import React, { useEffect, useRef, useState } from 'react'
import { SwitchIcon } from '../../../svgIcons/SwitchIcon'
import { numFormat } from '../../../blockchainUtils/math'
import BigNumber from 'bignumber.js'
import { useDebounce } from 'usehooks-ts'
import { useOnClickOutside } from '../../../hooks/useClickOutside'

function RangeSelector(props: {
    network: string
    isMax: boolean
    ticksChange: 1 | 2 | 10 | 60 | 200
    onUpdateCurrentTick: (tickChange: number) => void
    onUpdateCurrentTickByPrice: (price: string) => void
    tokenASymbol: string
    tokenBSymbol: string
    pricePerTokenB: BigNumber
    className?: string
    isOtherRatio?: boolean
    isReversed?: boolean
    setIsOtherRatio: () => void
    isDisabled?: boolean
}) {
    const {
        isMax,
        ticksChange,
        onUpdateCurrentTick,
        tokenASymbol,
        tokenBSymbol,
        className = '',
        pricePerTokenB,
        isOtherRatio,
        setIsOtherRatio,
        isReversed = false,
        isDisabled = false,
        onUpdateCurrentTickByPrice
    } = props

    const [isInput, setIsInput] = useState(false)
    const [tickInput, setTickInput] = useState('')
    const inputRef = useRef(null)
    const debouncedTickInput = useDebounce(tickInput, 1000)
    useOnClickOutside(inputRef, () => {
        if (isInput) setIsInput(false)
    })

    useEffect(() => {
        if (debouncedTickInput && debouncedTickInput.length > 0) {
            onUpdateCurrentTickByPrice(tickInput)
            setIsInput(false)
            setTickInput('')
        }
    }, [debouncedTickInput])

    function onUpdateCurrentTickClick(isPlus: boolean) {
        if (!isReversed) onUpdateCurrentTick(isPlus ? ticksChange : -ticksChange)
        if (isReversed) onUpdateCurrentTick(isPlus ? -ticksChange : ticksChange)
    }

    function updateTickInput(newValue: string) {
        setTickInput(newValue)
    }

    function renderAmount() {
        if (isInput)
            return (
                <input
                    ref={inputRef}
                    autoFocus={true}
                    type='number'
                    onChange={(e) => updateTickInput(e.target.value)}
                    className='outline-none max-w-[114px] text-center bg-[#0C3F6D] px-2 rounded-[6px] cursor-pointer my-1 text-4 lg:text-[18px] font-bold mx-1'
                    value={tickInput ? tickInput : `${isOtherRatio ? numFormat(BigNumber(1).dividedBy(pricePerTokenB).toString()) : numFormat(pricePerTokenB.toString())}`}></input>
            )
        return (
            <span onClick={() => setIsInput(true)} className='hover:bg-[#0C3F6D] px-2 rounded-[6px] cursor-pointer my-1 text-4 lg:text-[18px] font-bold mx-1'>{`${
                isOtherRatio ? numFormat(BigNumber(1).dividedBy(pricePerTokenB).toString()) : numFormat(pricePerTokenB.toString())
            }`}</span>
        )
    }
    function renderInformation() {
        const symbolA = isOtherRatio ? tokenASymbol : tokenBSymbol
        const symbolB = isOtherRatio ? tokenBSymbol : tokenASymbol

        return (
            <div className='flex flex-1 justify-center items-center flex-col text-white max-w-[110px] w-[110px]'>
                <span className='text-2 lg:text-4'>{`${isMax ? 'Max' : 'Min'} Price`}</span>
                {renderAmount()}
                <span
                    className='flex items-center cursor-pointer'
                    onClick={() => {
                        setIsOtherRatio()
                    }}>
                    <span className='flex text-[14px] items-center'>
                        <span>{symbolA}</span>
                        <span className='text-[12px] mx-1'>{'per'}</span>
                        {/* <span className='text-[12px] mx-1'>{'Per'}</span> */}
                        <span>{symbolB}</span>
                    </span>
                    <SwitchIcon className='ml-2 w-[18px] h-[18px] cursor-pointer' />
                </span>
            </div>
        )
    }

    function renderChangeIcon(isPlus: boolean) {
        return (
            <div
                onClick={() => {
                    isDisabled ? console.log('') : onUpdateCurrentTickClick(isPlus)
                }}
                className={`${
                    isDisabled ? 'cursor-not-allowed	' : 'cursor-pointer'
                } flex-shrink-0 select-none flex justify-center items-center  border border-[1px] z-[1] bg-[#0C1647] border-[#0C3F6D] rounded-full h-8 w-8 lg:h-9 lg:w-9 `}>
                <span className='select-none text-4'>{isPlus ? '+' : '-'}</span>
            </div>
        )
    }

    return (
        <div
            className={`max-w-[190px] lg:max-w-[100%] relative justify-between bg-[#0C1647] rounded-lg flex w-full p-2 lg:p-3 items-center ${className}`}
            style={{ boxShadow: '0px 3px 7px rgba(28, 28, 34, 0.33)' }}>
            {renderChangeIcon(false)}
            {renderInformation()}
            {renderChangeIcon(true)}
        </div>
    )
}

export default RangeSelector
